import { useEffect, useState } from "react";
import styled from "styled-components";
import ItemsDatabase from "./ItemsDatabase";
import { TipMouseOutEvent, TipMouseOverEvent } from "../../Tooltip/Tooltip";
import PotionImage from "./img/potionIcon.png"
import AnimalImage from "./img/wolf.png"
import MapImage from "./img/world-map.jpg"
import SkillImage from "./img/skillsIcon.png"
import MobsDatabase from "./MobsDatabase";

function Database() {

    function styleToggleFilterButton(e) {
    }

    const [databaseSelected, setDatabaseSelected] = useState(<ItemsDatabase/>);


    useEffect(() => {
        
        setTimeout(() => {
            document.getElementById('DatabaseMaster').style.opacity = "1";
        }, 300);
    },[]);

    return(
        <DatabaseContainer id='DatabaseMaster'>

            <TitleContainer>
                <Title>Database Geral</Title>
                <T1> <p>Selecione qual tipo de informação você deseja procurar.<br/></p></T1>      
            </TitleContainer>

            <DatabaseTypeContainer>

                <DatabaseOptionCategory className="databaseOption" onClick={(e) => {styleToggleFilterButton(e); setDatabaseSelected(<ItemsDatabase />)}}>
                    <DatabaseOption img={PotionImage}/>
                    <DatabaseOptionDescription>items</DatabaseOptionDescription>
                </DatabaseOptionCategory>

                <DatabaseOptionCategory className="databaseOption" onClick={(e) => {styleToggleFilterButton(e); setDatabaseSelected(<MobsDatabase/>)}}>
                    <DatabaseOption img={AnimalImage}/>
                    <DatabaseOptionDescription>monstros</DatabaseOptionDescription>
                </DatabaseOptionCategory>

                <DatabaseOptionCategoryDisabled className="databaseOption"
                onMouseOver={(event) => TipMouseOverEvent(event, `Disponível Em breve!`, "rgba(0, 0, 0, .5)")}
                onMouseLeave={() => TipMouseOutEvent()}>
                    <DatabaseOption img={MapImage}/>
                    <DatabaseOptionDescription>Mapas</DatabaseOptionDescription>
                </DatabaseOptionCategoryDisabled>

                <DatabaseOptionCategoryDisabled className="databaseOption"
                onMouseOver={(event) => TipMouseOverEvent(event, `Disponível Em breve!`, "rgba(0, 0, 0, .5)")}
                onMouseLeave={() => TipMouseOutEvent()}>
                    <DatabaseOption img={SkillImage}/>
                    <DatabaseOptionDescription>Habilidades</DatabaseOptionDescription>
                </DatabaseOptionCategoryDisabled>

            </DatabaseTypeContainer>

            {databaseSelected}

        </DatabaseContainer>

    );
}

export default Database;

const DatabaseContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    text-align: center;
    transition: 2s;
    margin-bottom: 10px;
    opacity: 0;
    //border: solid;

    @media (max-width: 1000px) {
    width: 90vw;
    margin-top: 30px;
    }

`;

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1280px;
    //border: solid;
    margin-bottom: 30px;

    @media (max-width: 1000px) {
    width: 90%;
    //text-align: justify;
    margin-bottom: 50px;
    }
`;

const Title = styled.span`
    font-size: 30pt;
    //border: solid;
    font-weight: bold;

    @media (max-width: 1000px) {
        font-size: 28pt;
        text-align: center;
    }
`;

const T1 = styled.div`
    //width: 1000px;
    padding: 0px 20px;
    //border: solid;
    text-align: center;
    font-size: 13pt;


    @media (max-width: 1000px) {
        width: 100%;
        overflow: auto;
        padding: 10px;
        border-radius: 10px;
        //box-shadow: 0 0 10px 0 black;
        font-size: 11pt;
    }

`;

const DatabaseTypeContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 5px;
    margin-bottom: 50px;
    //border: solid 1px;
    //border-radius: 10px;
    //background-color: rgba(0,0,0,.5);
    scale: .9;

    @media (max-width: 1000px) {
        width: 100%;
        flex-wrap: wrap;
        margin-bottom: 20px;
        justify-content: space-evenly;
    }

`

const DatabaseOptionCategory = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-conten: center;
    border-radius: 10px;
    //background-color: rgba(255, 255, 255, 1);
    filter: saturate(.8);
    margin: 0px 10px;

    transition: .2s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:hover {
        scale: 1.2;
        filter: saturate(1);
    }

    &:active {
        cursor: url('cursors0008.png'), pointer;
        scale: .9;
        opacity: .5;
    }

    @media (max-width: 1000px) {
        margin: 0px 0px 20px;
    }

`

const DatabaseOptionCategoryDisabled = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-conten: center;
    border-radius: 10px;
    //background-color: rgba(255, 255, 255, 1);
    filter: saturate(0);
    margin: 0px 10px;

    transition: .2s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:hover {
        //scale: 1.2;
        //filter: saturate(1);
    }

    &:active {
        cursor: url('cursors0008.png'), pointer;
        scale: .9;
        opacity: .5;
    }

`

const DatabaseOption = styled.div`
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 70px;
    height: 70px;
    margin: 0px 10px;
    //border: solid 2px;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 1);

`

const DatabaseOptionDescription = styled.span`
    font-size: 12pt;
    width: 100px;
    color: white;
    border: solid 1px black;
    border-radius: 5px;
    padding: 5px 10px;
    margin-top: 10px;
    background-color: rgba(0,0,0,.9);

`


